module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/98e078544198e1135c324f1b6d215820.png";